import { DEFAULT_AGENT_NAMED_ID, DEFAULT_AGENT_UUID } from '../../constants/private';

/**
 * This is util function based on hardcoded agent id in convo-ai for `AiMateAgent`
 * https://bitbucket.org/atlassian/conversational-ai-platform/src/main/modules/product/rovo/rovo-api/src/main/kotlin/io/atlassian/micros/convoai/product/rovo/agent/AiMateAgent.kt#lines-58
 */
export const isRovoCustomAgent = (agentId: string | null | undefined): boolean => {
	if (!agentId) {
		return false;
	}

	return agentId !== DEFAULT_AGENT_NAMED_ID && agentId !== DEFAULT_AGENT_UUID;
};
